import ReactController from '~/controllers/react_controller'
import AzureStorageDashboardCharts from '~/dashboard/azure_storage_dashboard_charts'

export default class AzureStorageDashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
  }

  createComponent() {
    return <AzureStorageDashboardCharts organizationId={this.organizationIdValue} />
  }
}
